import { render, staticRenderFns } from "./Accessibility.vue?vue&type=template&id=4a1dfb14&scoped=true&"
import script from "./Accessibility.vue?vue&type=script&lang=ts&"
export * from "./Accessibility.vue?vue&type=script&lang=ts&"
import style0 from "./Accessibility.vue?vue&type=style&index=0&id=4a1dfb14&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a1dfb14",
  null
  
)

export default component.exports